import type { ThesisFormState } from "./useThesisForm";

export function formFromThesisRequest(req: {
  degreeLevel: ThesisFormState["degreeLevel"];
  bindingType: ThesisFormState["bindingType"];
  title: string;
  supervisor?: string | null;
  pageCount: number;
  copies: number;
  colorPages: number;
  paperGrade?: string | null;
  formattingNotes?: string | null;
  fileUrl?: string | null;
}): ThesisFormState {
  return {
    degreeLevel: req.degreeLevel,
    bindingType: req.bindingType,
    title: req.title,
    supervisor: req.supervisor ?? "",
    pageCount: String(req.pageCount),
    copies: String(req.copies),
    colorPages: String(req.colorPages),
    paperGrade: req.paperGrade ?? "",
    formattingNotes: req.formattingNotes ?? "",
    fileUrl: req.fileUrl ?? "",
  };
}
